import {
  ClockCircleOutlined,
  CloseCircleOutlined,
  LoginOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import {Typography} from 'antd';
import React from 'react';
import cx from 'classnames';
import './TrxItem.css';

const {Text} = Typography;

const TrxItem = ({item}) => {
  const getIcon = () => {
    if (item.status === 'failed') return <CloseCircleOutlined />;
    if (item.status === 'pending') return <ClockCircleOutlined />;
    if (item.income) return <LoginOutlined />;
    return <LogoutOutlined />;
  };
  return (
    <div className={cx('trx-item', `trx-item--${item.status}`, {'trx-item--income': item.income})}>
      <div style={{fontSize: 24}}>{getIcon()}</div>
      <div className="trx-item__desc">
        <div className="trx-item__title">
          <a href={`https://ropsten.etherscan.io/tx/${item.id}`} target="_blank">
            {item.email}
          </a>
        </div>
        <div className="trx-item__date">{item.dateFormatted}</div>
      </div>
      <div className="trx-item__spacer" />
      <div className="trx-item__value">
        {item.income ? '+' : '-'} {item.amountFormatted}
      </div>
    </div>
  );
};

export default TrxItem;
